
import { computed, defineComponent, PropType } from 'vue'

import DeliveryCargoStatus from '@/modules/NewDispatcher/components/DeliveryCargoStatus/index.vue'

// @components
import Cheap from '@/common/components/UI/Cheap/index.vue'
import DeliveryTableRowActions from '@/modules/NewDispatcher/components/DeliveryTableRowActions/index.vue'

import { formatDateWithTimeFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    name: 'deliveries-table-row',
    components: {
        DeliveryCargoStatus,
        Cheap,
        DeliveryTableRowActions,
    },
    props: {
        row: {
            type: Object as PropType<any>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
        index: {
            type: Number,
            default: 0,
        },
    },
    emits: ['payment', 'wait-list'],
    setup(props, { emit }) {
        // const getCheckOrTimesIcon = (is_check: boolean) => {
        //     return `fas ${is_check ? 'fa-check text-green-500' : 'fa-times'}`
        // }

        const emitPayment = (type: number) => {
            emit('payment', type, props.row.invoiceId)
        }

        const emitWaitList = () => emit('wait-list', { ...props.row })

        const isWaitListId = computed(() => {
            return (
                props.column.key === 'waitListId' &&
                props.row.waitList &&
                props.row.waitList.state &&
                [48, 49].includes(props.row.waitList.state.id)
            )
        })

        return {
            //  getCheckOrTimesIcon,
            emitPayment,
            emitWaitList,
            isWaitListId,
            formatDateWithTimeFromBackend,
        }
    },
})
